import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ProductCard from '../components/ProductCard';
import withRouter from '../../../shared/utils/WithRouter';

class ProductCardContainer extends React.Component {
	constructor() {
		super();
		this.handleNavigation = this.handleNavigation.bind(this);
	}

	handleNavigation() {
		this.props.router.navigate(`/product/${this.props.id}`, {
			state: {
				sku: this.props.sku,
				categoryId: this.props.categoryId,
		}})
	}

	// The ProductCardContainer must be wrapped in a div with a set height.
	// See ProductsDisplay for example
	render() {
		const { isFetching, classes } = this.props;
		return (
			<ProductCard
				handleNav={this.handleNavigation}
				name={this.props.name}
				price={this.props.price}
				msrp={this.props.msrp}
				oldPrice={this.props.oldPrice}
				pictureUrl={this.props.pictureUrl}
				isFetching={isFetching}
				sku={this.props.sku}
				classes={classes}
			/>
		);
	}
}

ProductCardContainer.propTypes = {
	id: PropTypes.number.isRequired,
	isFetching: PropTypes.bool.isRequired,
	name: PropTypes.string.isRequired,
	pictureUrl: PropTypes.string,
	price: PropTypes.number,
	msrp: PropTypes.number,
	oldPrice: PropTypes.number,
	sku: PropTypes.string,
	categoryId: PropTypes.string.isRequired,
	classes: PropTypes.shape({
		productCardStyle: PropTypes.string,
		titleStyle: PropTypes.string,
		priceStyle: PropTypes.string,
		subtitleStyle: PropTypes.string,
		relatedProduct: PropTypes.string,
	}),
};

ProductCardContainer.defaultProps = {
	price: 0,
	msrp: 0,
	pictureUrl: '',
	sku: '',
	classes: undefined,
	oldPrice: 0,
};

const mapStateToProps = state => {
	const isFetching = state.product.get('isFetching');
	return {
		isFetching,
	};
};

// for testing purposes
export { ProductCardContainer as ProductCardContainerClass };

export default withRouter(connect(mapStateToProps)(ProductCardContainer));
